import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { AuthRecoverStateData } from './types';

const initialState: AuthRecoverStateData = {
	data: { data: { error: '', message: '', uid: '', success: '' }, error: null },
	loading: false,
	error: '',
};

export const fetchRecover = createAsyncThunk('api/fetchRecover', ({ login }: { login: string }) =>
	api.fetchRecover({ login }),
);

const authRecoverSlice = createSlice({
	name: 'recover',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchRecover.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchRecover.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchRecover.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			});
	},
});

export default authRecoverSlice.reducer;
